import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Visual indicator for pull-to-refresh. Positioned absolutely at the very
 * top of the viewport. Fades out when neither pulling nor refreshing.
 */
const PullToRefreshIndicator = ({ pull = 0, refreshing = false }) => {
  const visible = refreshing || pull > 0.05;
  const opacity = Math.min(1, pull * 1.4);
  const scale = Math.min(1, 0.4 + pull * 0.6);
  const rotation = pull * 360;

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none fixed top-0 left-0 right-0 z-[60] flex items-start justify-center pt-3 transition-opacity ${visible ? 'opacity-100' : 'opacity-0'}`}
      data-testid="pull-to-refresh"
    >
      <div
        className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-zinc-900/90 border border-red-500/40 shadow-[0_0_18px_rgba(220,38,38,0.5)] backdrop-blur"
        style={{
          opacity: refreshing ? 1 : opacity,
          transform: `scale(${refreshing ? 1 : scale}) rotate(${refreshing ? 0 : rotation}deg)`,
          transition: refreshing ? 'transform 0.3s ease-out' : 'none',
        }}
      >
        {refreshing ? (
          <Loader2 className="h-4 w-4 text-red-400 animate-spin" />
        ) : (
          <svg viewBox="0 0 24 24" className="h-4 w-4 text-red-400" fill="none" stroke="currentColor" strokeWidth={2.5}>
            <path d="M12 5v14M12 5l-5 5M12 5l5 5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
